import * as types from 'store/actions/types';

// Import helpers
import { matchChannelsEpg, formatChannels, setTvProgramsTime, updateCurrentLiveProgram } from 'store/helpers/epg';
import { fetchEpg, fetchChannelsList } from 'helpers/api/epg';
import { fetchSubscriberProductsUuids } from 'helpers/api/subscriber';

// ******************** FETCH TV PROGRAMMS ********************
export const fetchTvPrograms =
	({ isLoaded = false, isAuth = true } = {}) =>
	async (dispatch, getState) => {
		try {
			// Get program time, start , end
			const { since, till, isToday } = setTvProgramsTime();

			const { subscriber } = getState();

			// Dispatch an loading action
			isLoaded
				? dispatch({
						type: types.FETCH_TV_PROGRAMS_REFRESH_LOADING,
						payload: { since, till, isToday }
					})
				: dispatch({
						type: types.FETCH_TV_PROGRAMS_LOADING,
						payload: isLoaded
					});

			const channels = await fetchChannelsList();

			const products = await fetchSubscriberProductsUuids(isAuth);

			const localActive = Boolean(subscriber.details?.subscriber_local_active);

			// Fetch programs
			const epg = await fetchEpg(since, till);

			// Format channels, sort channels to avaiable and unavaiable
			const formattedChannels = formatChannels(channels, products, localActive);

			dispatch({
				type: types.SET_EPG_CHANNELS,
				payload: {
					lives: formattedChannels,
					now: since
				}
			});

			// Match epg to channel
			const lives = matchChannelsEpg(formattedChannels, epg);

			// Dispatch an action
			dispatch({
				type: types.FETCH_TV_PROGRAMS_SUCCESS,
				payload: {
					data: { now: since, lives },
					since,
					till,
					isToday,
					channels
				}
			});
		} catch (error) {
			// Dispatch an error action
			dispatch({
				type: types.FETCH_TV_PROGRAMS_ERROR,
				payload: true
			});
		}
	};

export const setTvProgramsDate = (date = null) => {
	const { since, till, isToday } = setTvProgramsTime(date);

	return {
		type: types.SET_TV_PROGRAMS_DATE,
		payload: { since, till, isToday }
	};
};

export const setTvProgramsLive = (channelId) => ({
	type: types.SET_TV_PROGRAM_LIVE,
	payload: channelId
});

export const updateCurrentLives = () => (dispatch, getState) => {
	const {
		channels: {
			data: { lives }
		}
	} = getState();

	if (lives) {
		const updatedLives = updateCurrentLiveProgram(lives);

		// Dispatch an action
		dispatch({
			type: types.WAKE_UP_UPDATE_CURRENT_TV_PROGRAMS,
			payload: updatedLives
		});
	}
};
